module.exports = __webpack_public_path__ + "static/media/3pl2.2b493faa.png";